import Gauge from '@/components/Gauge';
import { toPercentage } from '@/utilities/formatting';

export interface Props {
  portfolioName: string;
  ROCE: number;
}

const keys = ['portfolio'];

const ROCEGauge = ({ ROCE, portfolioName }: Props) => {
  const entities = {
    [keys[0]]: ROCE,
  };
  const entityTitles = {
    [keys[0]]: portfolioName,
  };
  return (
    <Gauge
      title="ROCE"
      keys={keys}
      entityTitles={entityTitles}
      entities={entities}
      formatter={(value: number | null) =>
        value !== null ? toPercentage(value, 1) : 'n/a'
      }
      numTicks={4}
      from={0}
      to={0.3}
    />
  );
};

export default ROCEGauge;
